import { SURF_APP_ID } from "../constants.js";
function normalizeAdminBase(url) {
    return url.trim().replace(/\/+$/, "");
}
async function adminFetch(cfg, path, query) {
    const base = normalizeAdminBase(cfg.adminApiBaseUrl);
    if (!base)
        throw new Error("admin-api non configurato.");
    const qs = query ? `?${new URLSearchParams(query).toString()}` : "";
    const url = `${base}${path}${qs}`;
    const request = async (forceRefresh) => {
        const token = await cfg.getIdToken(forceRefresh);
        return fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "X-Vida-AppId": SURF_APP_ID,
            },
        });
    };
    let res = await request(false);
    if (res.status === 401) {
        res = await request(true);
    }
    const text = await res.text();
    if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`);
    }
    return JSON.parse(text);
}
export async function fetchSurfCredits(cfg) {
    return adminFetch(cfg, "/api/me/credits");
}
export async function fetchSurfUsageBreakdown(cfg, days = 30) {
    const clamped = Math.min(Math.max(Math.floor(days), 1), 90);
    return adminFetch(cfg, "/api/me/usage/breakdown", {
        days: String(clamped),
    });
}
export function formatCreditsBalance(balanceCents) {
    return `€ ${(balanceCents / 100).toFixed(2)}`;
}
export function maskUserSub(sub) {
    const trimmed = sub.trim();
    if (trimmed.length <= 10)
        return trimmed;
    return `${trimmed.slice(0, 6)}…${trimmed.slice(-4)}`;
}
